import React from 'react';
import { useTranslation } from "react-i18next";
import { Text, Box, MantineProvider, Alert, Accordion } from '@mantine/core';

import AccordionItem from "../payment/AccordionItem";
import Bundles from "../payment/Bundles";

export default function Open() {
  const { t } = useTranslation();
  return (
    <Box>
      <MantineProvider theme={{ primaryShade: 6 }}>
        <Alert color="gray" radius="md" mt={15}>
          <Text>
            {t("spaces.settings.privacy.open.open.description")}
          </Text>
        </Alert>
      </MantineProvider>
      <Accordion>
        <Accordion.Item
          label={
            <AccordionItem
              accordionState={{ 0: false }}
              index={0}
              label={"Bundles"}
              key={"bundles"}
              description={`Bundles allow you to package access to multiple spaces with one purchase.  You can have them show up on your checkout page or add a bundle button from the block menu on any content page.`}
            />
          }
        >
          <Bundles />
        </Accordion.Item>
      </Accordion>
    </Box>
  );
}
